<div class="share-container">
  <form [formGroup]="shareWeeklyEmailForm">

    <!-- Header -->
    <div class="dialog-header">
      <span class="dialog-title">Share Consol Planning</span>
      <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
    </div>

    <div class="body">

      <!-- Customer -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Customer</mat-label>
        <mat-select formControlName="customerId" panelClass="dropdown-large" (selectionChange)="setCustomerValueChangeEvent($event.value)">
          <mat-option>
            <ngx-mat-select-search [searching]="searching" [formControl]="customerSearchCtrl"
              noEntriesFoundLabel="No matching customer found"
              placeholderLabel="🔍 Search customer by name">
              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          @for (customer of (filteredCustomers | async); track customer) {
            <mat-option [value]="customer.id">
              {{ customer.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Orientation -->
      <!-- <p class="sub-label">Layout</p> -->
      <mat-radio-group formControlName="planningOrientation" class="radio-row">
        <mat-radio-button value="HORIZONTAL" color="primary" class="radio-btn">
          <span class="radio-label"><mat-icon>view_column</mat-icon> Horizontal</span>
        </mat-radio-button>
        <mat-radio-button value="VERTICAL" color="primary" class="radio-btn">
          <span class="radio-label"><mat-icon>view_stream</mat-icon> Vertical</span>
        </mat-radio-button>
      </mat-radio-group>

      <!-- Select Email IDs -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Email IDs</mat-label>
        <mat-select multiple formControlName="selectedEmails"
          (selectionChange)="onEmailSelectChange($event.value)">
          @for (email of emailList; track email) {
            <mat-option [value]="email">{{ email }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (customerSelected && emailList?.length === 0) {
        <p class="warn-msg">
          No email IDs found for this customer
        </p>
      }

      <!-- Add Email Manually -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Add Email IDs</mat-label>
        <mat-chip-grid #chipList formControlName="enteredEmails" class="chip-list">
          @for (email of emailsList; track email; let i = $index) {
            <mat-chip-row [removable]="true"
              (removed)="removeEmailByIndex(i)">
              {{ i+1 }}. {{ email }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input #emailInput matInput placeholder="Type and press Enter" [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addEmail($event, emailInput)" required />
          <mat-error>At least one email is required</mat-error>
        </mat-form-field>
      </div>

      <!-- Footer -->
      <div class="footer">
        <button mat-raised-button color="primary" (click)="sendEmail()">Send Email</button>
      </div>

    </form>
  </div>